import Grid from "@mui/material/Grid2";
import i18nStore from "../../../i18n/store";
import { IncomeInviteSchema } from "../schemas";
import { Button } from "@mui/material";
import * as React from "react";
import UserPreview from "../../../components/UsersPreview/UserPreview";
import Typography from "@mui/material/Typography";
import InvitesApi from "../api";
import invitesStore from "../store";


interface IncomeInviteProps {
    invite: IncomeInviteSchema;
}
const IncomeInvite = (props: IncomeInviteProps) => {
    const translations = i18nStore.getTranslations;

    const acceptInvite = () => {
        InvitesApi.accept_invite(props.invite.id).then(() => {
            invitesStore.removeInviteById(props.invite.id);
        });
    };
    const rejectInvite = () => {
        InvitesApi.reject_invite(props.invite.id).then(() => {
            invitesStore.removeInviteById(props.invite.id);
        });
    };

    return (
        <>
            <Grid container spacing={2}>
                <Grid size={5}>
                    <UserPreview user={props.invite.inviter} />
                </Grid>
                <Grid size={4} sx={{ display: "flex", alignItems: "center" }}>
                    <Typography variant="subtitle2">{props.invite.project.title} - {props.invite.project.description}</Typography>
                </Grid>
                <Grid size={3} sx={{ display: "flex", alignItems: "center" }}>
                    <Button
                        variant="contained"
                        color="success"
                        sx={{ minWidth: "50px", mx: 1, py: 0.5, }}
                        onClick={acceptInvite}
                    >
                        {translations.accept}
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        sx={{ minWidth: "50px", mx: 1, py: 0.5, }}
                        onClick={rejectInvite}
                    >
                        {translations.reject}
                    </Button>
                </Grid>
            </Grid>
        </>
    );
};

export default IncomeInvite;
